import * as React from 'react'
import { tw } from 'utils/classnames'
import { Slot } from 'primitives/slot'

interface MenuItemProps extends Omit<React.ComponentProps<'button'>, 'ref'> {
  asChild?: boolean
  selected?: boolean
  ref?: React.Ref<HTMLButtonElement>
}

export const MenuItem = function ActionMenuItem({
  ref,
  asChild,
  selected,
  className,
  ...props
}: MenuItemProps) {
  const Component = asChild ? Slot : 'button'

  return (
    <Component
      className={tw(
        'rounded-2 group box-border flex cursor-pointer flex-row items-center p-2 text-gray-400 outline-none hover:bg-gray-800 hover:text-gray-50 [&>svg]:size-6',
        'disabled:cursor-not-allowed disabled:text-theme_semantic_surface_ui_foreground-color-disabled disabled:hover:bg-transparent disabled:hover:text-theme_semantic_surface_ui_foreground-color-disabled',
        selected && 'bg-gray-800 text-gray-50',
        className,
      )}
      {...props}
      ref={ref}
    />
  )
}

export function MenuItemText({ ...props }: React.ComponentProps<'p'>) {
  return (
    <p
      className={tw('ml-3 mr-auto flex-grow whitespace-nowrap text-left', props.className)}
      {...props}
    />
  )
}
